var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusMarkerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0070B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6468 15.7812C29.5449 13.0172 33.4551 13.0172 34.3532 15.7812L36.3271 21.8561C36.7287 23.0922 37.8805 23.9291 39.1802 23.9291H45.5678C48.474 23.9291 49.6823 27.6479 47.3312 29.3561L42.1635 33.1107C41.112 33.8746 40.6721 35.2287 41.0737 36.4648L43.0476 42.5398C43.9456 45.3037 40.7822 47.6021 38.431 45.8939L33.2634 42.1393C32.2119 41.3754 30.7881 41.3754 29.7366 42.1393L24.569 45.8939C22.2178 47.6021 19.0544 45.3037 19.9524 42.5398L21.9263 36.4648C22.3279 35.2287 21.888 33.8746 20.8365 33.1107L15.6688 29.3561C13.3177 27.6479 14.526 23.9291 17.4322 23.9291H23.8198C25.1195 23.9291 26.2713 23.0922 26.6729 21.8561L28.6468 15.7812Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusMarkerIcon);
export default __webpack_public_path__ + "static/media/status-marker-icon.c06505d16c877491b66854107b25bae5.svg";
export { ForwardRef as ReactComponent };